export default __webpack_public_path__ + "static/gantry_built-3a84520602927b6cc2c4af542d211aaf.jpg";